export default "__VITE_ASSET__BW3q1cfz__"